import { vars } from "@common/styles";
import { rgba } from "polished";
import styled, { css } from "styled-components";

export const TooltipContainer = styled.span`
  width: 100%;
  position: relative;
  display: inline-block;
  border: 0 solid transparent;
  user-select: none;
`;

export const TooltipContent = styled.span<{
  $prewrap?: boolean;
}>`
  z-index: ${vars.zIndex.tooltip};
  pointer-events: none;
  position: absolute;
  color: ${vars.colors.grey30} !important;
  padding: 0.5rem 1.5rem;
  border: 1px solid ${vars.colors.grey90};
  box-shadow: 0 0.2rem 1rem ${vars.colors.black};
  border-radius: 0.5rem;
  background-color: ${rgba(vars.colors.grey100, 1)};
  color: ${vars.colors.grey30};
  text-align: center;
  font-size: 1.4rem;
  max-width: 500px;
  white-space: nowrap;
  overflow-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(props) =>
    props.$prewrap &&
    css`
      text-align: start;
      white-space: pre;
    `}
`;
